import { recordTrack } from '@saucelabs/sl-util-segmentio';

import * as actions from './actions';


export const initializeFilters = ({ username, fetchUsers, fetchTeams }) => (dispatch) => (
  Promise.all([
    fetchUsers ? dispatch(actions.getOrgUsers(username)) : Promise.resolve(),
    fetchTeams ? dispatch(actions.getTeamList()) : Promise.resolve(),
  ])
    .then(() => dispatch(actions.filtersInitialized()))
);

export const cleanup = () => (dispatch) => (
  dispatch(actions.clearRdcOffset())
);

export const recordTrackView = (view) => (dispatch) => {
  const dashOptions = {
    builds: 'Automated Builds',
    manual: 'Live Tests',
    tests: 'Automated Tests',
    onboarding: 'Onboarding',
  };
  dispatch(recordTrack(`${dashOptions[view]} Tab viewed.`));
};
